import { render, staticRenderFns } from "./sm-hateoas-table.vue?vue&type=template&id=179ab3b6&"
import script from "./sm-hateoas-table.vue?vue&type=script&lang=js&"
export * from "./sm-hateoas-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports